import { ActivityTab } from './types';

export const ACTIVITY_TAB_PARAM = 'activity-tab';
export const LEGACY_ACTIVITY_TAB = 'pointChanges';
export const DEFAULT_ACTIVITY_TAB: ActivityTab = 'transactions';
export const ACTIVITY_TABS: ActivityTab[] = [
  'pointExpirations',
  'storedValueExpirations',
  'transactions',
  'stateChanges',
];
